export const formatDuration = (ms: number): string => {
  const SECOND = 1000;
  const MINUTE = 60 * SECOND;
  const HOUR = 60 * MINUTE;
  const DAY = 24 * HOUR;

  if (ms < HOUR) {
    const minutes = Math.floor(ms / MINUTE);
    return `${minutes} minute${minutes !== 1 ? "s" : ""}`;
  } else if (ms < DAY) {
    const hours = Math.floor(ms / HOUR);
    const minutes = Math.floor((ms % HOUR) / MINUTE);
    return (
      `${hours} hour${hours !== 1 ? "s" : ""}` +
      (minutes ? ` ${minutes} minute${minutes !== 1 ? "s" : ""}` : "")
    );
  } else {
    const days = Math.floor(ms / DAY);
    const hours = Math.floor((ms % DAY) / HOUR);
    return (
      `${days} day${days !== 1 ? "s" : ""}` +
      (hours ? ` ${hours} hour${hours !== 1 ? "s" : ""}` : "")
    );
  }
};
